import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Space, Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import AuthShell from "components/auth/AuthShell";
import AuthBrand from "components/auth/AuthBrand";
import paths from "routes/paths";

const { Title, Paragraph } = Typography;

const AuthRecoverSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(paths.simpleLogin, {
      replace: true,
      state: {
        recoveryNotice:
          "Your password was updated successfully. Redirecting you to sign in...",
      },
    });
  }, [navigate]);

  return (
    <AuthShell>
      <Card
        variant="borderless"
        style={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 28,
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.10)",
          border: "1px solid rgba(226,232,240,0.95)",
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(18px)",
          textAlign: "center",
        }}
        styles={{ body: { padding: 32 } }}
      >
        <div style={{ marginBottom: 24, textAlign: "center" }}>
          <AuthBrand centered size={96} />
        </div>
        <Space vertical size={14} style={{ width: "100%" }}>
          <CheckCircleFilled style={{ fontSize: 56, color: "#22c55e" }} />
          <Title level={2} style={{ margin: 0, color: "#111827" }}>
            Redirecting to sign in
          </Title>
          <Paragraph style={{ marginBottom: 0, color: "#475569" }}>
            Your password has been updated successfully. We are taking you back to
            the login screen now.
          </Paragraph>
        </Space>

        <Button
          type="primary"
          onClick={() =>
            navigate(paths.simpleLogin, {
              replace: true,
              state: {
                recoveryNotice:
                  "Your password was updated successfully. Redirecting you to sign in...",
              },
            })
          }
          style={{ marginTop: 24, backgroundColor: "#22c55e", borderColor: "#22c55e" }}
        >
          Go to sign in
        </Button>
      </Card>
    </AuthShell>
  );
};

export default AuthRecoverSuccess;
